import React from 'react';

const OilChangeModal = ({
  isOilChangeModalOpen,
  setIsOilChangeModalOpen,  
  changeOilDetails,
  changeOilViscosityDetails,
  changeOilVolumeDetails,
  filterDetails,
  subCategoriesServices,
  brandId,
  setBrandId,
  viscosityId,
  setViscosityId,
  volumeId,
  setVolumeId,
  filterId,
  setFilterId,
  isEdit,
  toggleSubCategories,
  createOilService,
}) => {
  return (
    isOilChangeModalOpen && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={isOilChangeModalOpen ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            <div className="modal-header orderDetails-modalHeader px-4">
              {isEdit ? (
                <i
                  className="fa-solid fa-circle-xmark fa-xl cursor"
                  onClick={() => setIsOilChangeModalOpen(false)}  
                ></i>
              ) : (
                <i
                  onClick={toggleSubCategories}
                  className="fa-solid fa-chevron-left cursor"
                ></i>
              )}
              <div className="d-flex align-items-center mx-auto">
                <p className="modal-title orderDetails-modalTitle mx-3 fs-3 fw-semibold">
                  تغيير الزيوت والفلاتر
                </p>
                <i className="fa-solid fa-rotate fa-xl text-warning"></i>
              </div>
            </div>
            <div className="modal-body orderDetails-modalBody p-3">
              {/* Oil Brand */}
              <div className="text-end my-2">
                <label>نوع الزيت</label>
                <select
                  className="form-select my-2"
                  value={brandId}
                  onChange={(e) => setBrandId(e.target.value)}
                >
                  <option value="">نوع الزيت</option>
                  {changeOilDetails?.oil_brands?.map((brand) => (
                    <option key={brand.id} value={brand.id}>
                      {brand.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Oil Viscosity */}
              <div className="text-end my-2">
                <label>لزوجة الزيت</label>
                <select
                  className="form-select my-2"
                  disabled={!brandId}
                  value={viscosityId}
                  onChange={(e) => setViscosityId(e.target.value)}
                >
                  <option value="">لزوجه الزيت</option>
                  {changeOilViscosityDetails?.oil_viscosities?.map((viscosity) => (
                    <option key={viscosity.id} value={viscosity.id}>
                      {viscosity.grade}
                    </option>
                  ))}
                </select>
              </div>

              {/* Oil Volume */}
              <div className="text-end my-2">
                <label>حجم العبوة</label>
                <select
                  className="form-select my-2"
                  disabled={!viscosityId}
                  value={volumeId}
                  onChange={(e) => setVolumeId(e.target.value)}
                >
                  <option value="">حجم العبوة</option>
                  {changeOilVolumeDetails?.volumes?.map((volume) => (
                    <option key={volume.id} value={volume.id}>
                      {volume.volume} {volume.unit}
                    </option>
                  ))}
                </select>
              </div>

              {/* Filter Type */}
              <div className="text-end my-2">
                <label>نوع الفلتر</label>
                <select
                  className="form-select my-2"
                  value={filterId}
                  onChange={(e) => setFilterId(e.target.value)}
                >
                  <option value="">نوع الفلتر</option>
                  {filterDetails?.filters?.map((filter) => (
                    <option key={filter.id} value={filter.id}>
                      {filter.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Price Breakdown */}
              <div className="d-flex justify-content-evenly text-end my-4">
                <div>
                  {viscosityId && (
                    <p>
                      {changeOilViscosityDetails?.oil_viscosities?.find(
                        (viscosity) => viscosity.id === parseInt(viscosityId)
                      )?.grade}{" "}
                      : الزوجة
                    </p>
                  )}
                  {volumeId && (
                    <p>
                      اجمالي تغيير الزيت :{" "}
                      {changeOilVolumeDetails?.volumes?.find(
                        (volume) => volume.id === parseInt(volumeId)
                      )?.price}{" "}
                      ج.م
                    </p>
                  )}
                  {filterId && (
                    <p>
                      اجمالي تغيير الفلتر :{" "}
                      {filterDetails?.filters?.find(
                        (filter) => filter.id === parseInt(filterId)
                      )?.price}{" "}
                      ج.م
                    </p>
                  )}
                </div>
                <div>
                  {brandId && (
                    <p>
                      النوع :{" "}
                      {changeOilDetails?.oil_brands?.find(
                        (brand) => brand.id === parseInt(brandId)
                      )?.name}
                    </p>
                  )}
                  {volumeId && (
                    <p>
                      الحجم :{" "}
                      {changeOilVolumeDetails?.volumes?.find(
                        (volume) => volume.id === parseInt(volumeId)
                      )?.volume}{" "}
                      {changeOilVolumeDetails?.volumes?.find(
                        (volume) => volume.id === parseInt(volumeId)
                      )?.unit}
                    </p>
                  )}
                  {filterId && (
                    <p>
                      {filterDetails?.filters?.find(
                        (filter) => filter.id === parseInt(filterId)
                      )?.name}{" "}
                      : نوع الفلتر
                    </p>
                  )}
                </div>
              </div>

              {/* Total Price */}
              {subCategoriesServices[1]?.price > 0 && (
                <div className="bg-secondary d-flex justify-content-between p-3 rounded-3 bg-opacity-25">
                  <p className="my-0 fw-semibold">
                    {subCategoriesServices[1]?.price} EGP
                  </p>
                  <p className="my-0 fw-semibold">الاجمالي</p>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="modal-footer mx-auto">
              <button
                type="button"
                className="btn btn-dark px-5 fs-5"
                onClick={createOilService}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default OilChangeModal;
